import SvgIcon from '@mui/material/SvgIcon';
import classNames from 'classnames';

import { useStyles } from './Reactions.styles';
import { ReactionProps } from './Reactions.types';

export const HeartIcon = ({
  size = 'default',
  color = 'secondary',
}: ReactionProps) => {
  const { classes } = useStyles();

  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(
        classes[`icon_size_${size}` as const],
        classes[`icon_color_${color}` as const],
      )}
    >
      <g clipPath="url(#clip0_4706_230033)">
        <path
          d="M16.1226 3.93061C14.3623 2.6285 11.5735 2.71469 10.0702 4.37749C9.98392 4.47296 9.82976 4.4709 9.74466 4.37435C8.37635 2.82181 5.42899 2.59524 3.68822 3.93061C2.20555 5.06799 1.27509 7.86602 3.48275 11.5607C5.23647 14.4956 8.20258 16.7419 9.90541 16.7419C11.6082 16.7419 14.6382 14.6807 16.4901 11.5607C18.7195 7.80452 17.623 5.04047 16.1226 3.93061Z"
          fill="url(#paint0_linear_4706_230033)"
        />
        <path
          d="M16.1226 3.93061C14.3623 2.6285 11.5735 2.71469 10.0702 4.37749C9.98392 4.47296 9.82976 4.4709 9.74466 4.37435C8.37635 2.82181 5.42899 2.59524 3.68822 3.93061C2.20555 5.06799 1.27509 7.86602 3.48275 11.5607C5.23647 14.4956 8.20258 16.7419 9.90541 16.7419C11.6082 16.7419 14.6382 14.6807 16.4901 11.5607C18.7195 7.80452 17.623 5.04047 16.1226 3.93061Z"
          fill="url(#paint1_radial_4706_230033)"
          style={{ mixBlendMode: 'lighten' }}
        />
        <path
          d="M16.1226 3.93061C14.3623 2.6285 11.5735 2.71469 10.0702 4.37749C9.98392 4.47296 9.82976 4.4709 9.74466 4.37435C8.37635 2.82181 5.42899 2.59524 3.68822 3.93061C2.20555 5.06799 1.27509 7.86602 3.48275 11.5607C5.23647 14.4956 8.20258 16.7419 9.90541 16.7419C11.6082 16.7419 14.6382 14.6807 16.4901 11.5607C18.7195 7.80452 17.623 5.04047 16.1226 3.93061Z"
          fill="url(#paint2_radial_4706_230033)"
          style={{ mixBlendMode: 'lighten' }}
        />
        <g opacity="0.8">
          <path
            d="M9.64071 7.35514C9.34581 5.66001 9.88922 4.7293 10.0124 4.4297C9.75038 4.50123 9.71625 4.27806 9.44965 4.0816C8.86763 3.56533 8.12723 3.32794 8.12723 3.32794C8.12723 3.32794 7.75906 6.09735 9.64071 7.35514Z"
            fill="url(#paint3_radial_4706_230033)"
            style={{ mixBlendMode: 'lighten' }}
          />
        </g>
        <g opacity="0.8" filter="url(#filter0_f_4706_230033)">
          <path
            d="M6.56962 10.2246C8.58788 9.73725 9.91882 7.78852 9.54236 5.87197C9.16591 3.95542 7.22461 2.79681 5.20635 3.28414C3.1881 3.77147 1.85716 5.7202 2.23361 7.63675C2.61007 9.5533 4.55137 10.7119 6.56962 10.2246Z"
            fill="url(#paint4_radial_4706_230033)"
          />
        </g>
        <g opacity="0.9" filter="url(#filter1_f_4706_230033)">
          <path
            d="M11.7682 9.24286C13.7235 10.4506 16.1421 10.2473 17.1701 8.78865C18.1982 7.33004 17.4465 5.16854 15.4912 3.96079C13.5359 2.75304 11.1173 2.95641 10.0893 4.41501C9.06119 5.87361 9.81287 8.03512 11.7682 9.24286Z"
            fill="url(#paint5_radial_4706_230033)"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_4706_230033"
          x="-17.8301"
          y="-16.8271"
          width="47.4365"
          height="47.1631"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="10"
            result="effect1_foregroundBlur_4706_230033"
          />
        </filter>
        <filter
          id="filter1_f_4706_230033"
          x="-10.3711"
          y="-16.8271"
          width="48.002"
          height="46.8584"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="10"
            result="effect1_foregroundBlur_4706_230033"
          />
        </filter>
        <linearGradient
          id="paint0_linear_4706_230033"
          x1="9.90926"
          y1="4.23334"
          x2="12.2357"
          y2="17.9071"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF4F37" />
          <stop offset="0.42" stopColor="#EA002D" />
          <stop offset="1" stopColor="#D30D81" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_4706_230033"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.00258 7.29804) rotate(45.6577) scale(10.3166 12.099)"
        >
          <stop offset="0.395833" stopColor="#FF4570" stopOpacity="0" />
          <stop offset="0.790094" stopColor="#750A77" stopOpacity="0.8" />
          <stop offset="0.994222" stopColor="#F459AD" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_4706_230033"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.81653 10.2795) rotate(-89.2763) scale(7.24683 9.92687)"
        >
          <stop offset="0.801724" stopColor="#FE789B" stopOpacity="0" />
          <stop offset="1" stopColor="#F11414" stopOpacity="0.41" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_4706_230033"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.82417 4.60584) rotate(153.646) scale(3.16003 2.94526)"
        >
          <stop offset="0.106246" stopColor="#CA1010" />
          <stop offset="0.681366" stopColor="#FF3537" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_4706_230033"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(5.91366 6.673) rotate(-13.5749) scale(3.78255 3.55503)"
        >
          <stop stopColor="#FFB6B6" stopOpacity="0.6" />
          <stop offset="1" stopColor="#FF0027" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_4706_230033"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.7796 6.73073) rotate(31.7023) scale(4.10559 3.18197)"
        >
          <stop stopColor="#FF9999" stopOpacity="0.6" />
          <stop offset="1" stopColor="#FF1F1F" stopOpacity="0" />
        </radialGradient>
        <clipPath id="clip0_4706_230033">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
